import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import { AppLayout } from 'components/AppLayout';

function PrivateRoutes({ redirectPath }) {
  const auth = useAuth();

  if (!auth) {
    return <Navigate to={redirectPath} />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}

export { PrivateRoutes };
